import { DashboardModuleLayoutWidget } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { GridItemData } from 'vue-grid-layout'

export enum DashboardModuleBaseAreaEnumActions {
    DASHBOARD_ADD_WIDGET = 'dashboard/addWidget',
    DASHBOARD_REMOVE_WIDGET = 'dashboard/removeWidget',
}

export interface DashboardModuleBaseAreaStateInfoWidget extends GridItemData {
    info: DashboardModuleLayoutWidget
}

export interface DashboardModuleBaseAreaState {
    unsubscribe: Function
    widgets: DashboardModuleBaseAreaStateInfoWidget[]
}
export const initialDashboardModuleBaseAreaState =
    (): DashboardModuleBaseAreaState => ({
        unsubscribe: () => {},
        widgets: []
    })
